<template>
<div class="nj-input-select" @click="stopPropagation($event)">
    <div class="nj-label">{{ label }}</div>
    <div style="position: relative;">
        <input type="text" class="nj-input-select--text" v-model="text" @keyup="searchKeyup($event)" @keyup.enter="selectFirstItem()" @keyup.esc="hide()" :disabled="disabled" @click="show()" placeholder="seleccionar...">
        <i class="nj-input-select--close mdi-close" @click="selectItem(null)" v-if="showRemove"></i>
        <div class="nj-input-select--items" @keydown="navigate($event)">
            <div class="nj-input-select--item" v-for="item in items" :key="item[itemKey]" @keyup.enter="selectItem(item)" @click="selectItem(item)" :tabindex="0">
                <slot :item="item"></slot>
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default {
    name: "InputSelect",
    props: {
        value: null,
        label: {
            type: String,
            default: "Label"
        },
        itemKey: {
            type: String,
            required: true
        },
        itemValue: {
            type: String,
            required: true
        },
        itemFilter: {
            type: String,
            default: null
        },
        source: {
            type: Array,
            default: []
        },
        labelFunction: {
            type: Function,
            required: true
        },
        filterFunction: {
            type: Function,
            default: null,
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    components: {

    },
    computed: {

    },
    watch: {
        source(newSource) {
            if (newSource != null) {
                this.selectedItem()
            }
        },
        value(newValue) {
            if (newValue != null) {
                this.selectedItem()
            }
        }
    },
    data() {
        return {
            text: null,
            items: [],
            width: "100%",
            showRemove: false
        }
    },
    methods: {
        show() {
            this.items = this.source
        },
        hide() {
            this.items = []
        },
        search() {
            if (this.itemFilter != null) {
                if (this.text != null) {
                    this.items = this.source.filter(item => item[this.itemFilter].toLowerCase().includes(this.text.toLowerCase()))
                }
                else {
                    this.items = [...this.source]
                }
            }
            else {
                this.items = this.filterFunction(this.source, this.text)
            }
        },
        searchKeyup(event) {
            this.stopPropagation(event)
            if (event.code != "CloseLeft"
                && event.code != "CloseRight"
                && event.code != "CloseUp"
                && event.code != "CloseDown"
                && event.code != "Escape"
                && event.code != "Tab"
            ) {
                this.search()
            }
        },
        selectItem(item) {
            this.$emit("input", item ? item[this.itemValue] : null)
            this.$emit("selectItem", item)
            this.text = item ? this.labelFunction(item) : null
            this.items = []
            this.showRemove = item && !this.disabled ? true : false
        },
        selectFirstItem() {
            if (this.items.length != 0) {
                let _item = this.items[0]
                this.selectItem(_item)
            }
        },
        selectedItem() {
            if (this.value) {
                const item = this.source.find(_item => _item[this.itemKey] == this.value)
                this.selectItem(item)
            }
            else {
                this.selectItem(null)
            }
        },
        navigate(event) {
            switch (event.code) {
                case "ArrowDown":
                    event.preventDefault()
                    this.nextItem()
                    break
                case "ArrowUp":
                    event.preventDefault()
                    this.previousItem()
                    break
            }
        },
        nextItem() {
            const item = document.activeElement
            if (item.nextElementSibling) {
                item.nextElementSibling.focus()
            }
        },
        previousItem() {
            const item = document.activeElement
            if (item.previousElementSibling) {
                item.previousElementSibling.focus()
            }
        },
        stopPropagation(event) {
            if (event) {
                event.stopPropagation()
            }
        },
    },
    mounted() {
        window.addEventListener("click", this.hide)
    }
}
</script>

<style scoped>
.nj-input-select {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}

.nj-input-select--label {
    display: block;
    padding: 6px 4px;
}

.nj-input-select--text {
    cursor: pointer;
    line-height: 18px;
    color: #666;
    width: 100%;
    outline: none;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    font-size: var(--font-size);
    border-radius: var(--radius);
    padding: 4px 22px 4px 6px;
}

.nj-input-select--text:disabled {
    background-color: var(--bg-disabled);
}

.nj-input-select--items {
    width: 100%;
    background-color: #fff;
    box-shadow: 0 4px 6px -2px #00000024;
    position: absolute;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 10;
}

.nj-input-select--item {
    border: 1px solid #ccc;
    border-top: none;
    cursor: pointer;
    padding: 8px;
}

.nj-input-select--item:focus,
.nj-input-select--item:hover {
    background-color: #eee;
    outline: none !important;
}

.nj-input-select--close {
    cursor: pointer;
    position: absolute;
    right: 4px;
    top: 5px;
}
</style>